import { render } from "./SaveAsModelModal.vue?vue&type=template&id=07c89f3f&scoped=true"
import script from "./SaveAsModelModal.vue?vue&type=script&lang=js"
export * from "./SaveAsModelModal.vue?vue&type=script&lang=js"

import "./SaveAsModelModal.vue?vue&type=style&index=0&id=07c89f3f&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c89f3f"]])

export default __exports__